// extracted by mini-css-extract-plugin
export var innerStyle = "modal_contain-module--innerStyle--A+oPI";
export var modalInnerOverflowStyle = "modal_contain-module--modalInnerOverflowStyle--ffKOa";